import { Button, ButtonProps } from '@mantine/core';
import { ComponentPropsWithoutRef, FC } from 'react';

type SliderButtonProps = {
	active?: boolean;
} & ButtonProps &
	Omit<ComponentPropsWithoutRef<'button'>, 'onClick'> & {
		onClick?(...args: unknown[]): void;
	};

export const SliderButton: FC<SliderButtonProps> = ({
	children,
	active,
	...other
}) => {
	return (
		<Button
			color={active ? 'rgba(242, 244, 247, 1)' : ''}
			autoContrast={active}
			variant="filled"
			radius="xl"
			p={'8px 10px'}
			{...other}
		>
			{children}
		</Button>
	);
};
